<template>
  <v-dialog
    v-model="showModal"
    max-width="1000"
  >
    <v-card class="text-center">
      <validation-observer 
        ref="validator"
        v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          <template v-if="isCreate">
            Thêm mới mối quan hệ
          </template>
          <template v-else>
            Cập nhật mối quan hệ
          </template>

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="hideModal"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                :rules="{ required: true, max: 255 }"
                name="Mối quan hệ"
              >
                <v-text-field
                  v-model="status.name"
                  :error-messages="errors"
                  :disabled="status.isRequired"
                  label="Mối quan hệ *"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                :rules="{ required: true, max: 20, regex: regex.isUsername }"
                name="Mã"
              >
                <v-text-field
                  v-model="status.code"
                  :error-messages="errors"
                  :disabled="status.isRequired"
                  label="Mã *"
                  color="primary"
                  class="input-code"
                />
              </validation-provider>
            </v-col>

            <v-col
              v-if="status.store == 'T' || (status.id && status.type.slice(0,1) == 'T')"
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Thuộc T"
              >
                <v-autocomplete
                  v-model="status.type"
                  :items="contactStatusTOptions"
                  :error-messages="errors"
                  :disabled="status.isRequired"
                  item-text="text"
                  item-value="value"
                  label="Thuộc T *"
                  color="primary"
                />
              </validation-provider>
            </v-col>

            <v-col
              v-if="status.store == 'C' || (status.id && status.type.slice(0,1) == 'C')"
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Thuộc C"
              >
                <v-autocomplete
                  v-model="status.type"
                  :items="contactStatusCOptions"
                  :error-messages="errors"
                  :disabled="status.isRequired"
                  item-text="text"
                  item-value="value"
                  label="Thuộc C *"
                  color="primary"
                />
              </validation-provider>
            </v-col>

            <v-col
                v-if="status.store == 'M' || (status.id && status.type.slice(0,1) == 'M')"
                cols="12"
                md="6"
            >
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  rules="required"
                  name="Thuộc M"
              >
                <v-autocomplete
                    v-model="status.type"
                    :items="contactStatusMOptions"
                    :error-messages="errors"
                    :disabled="status.isRequired"
                    item-text="text"
                    item-value="value"
                    label="Thuộc M *"
                    color="primary"
                />
              </validation-provider>
            </v-col>

            <v-col
                v-if="status.store == 'G' || (status.id && status.type.slice(0,1) == 'G')"
                cols="12"
                md="6"
            >
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  rules="required"
                  name="Thuộc G"
              >
                <v-autocomplete
                    v-model="status.type"
                    :items="contactStatusGOptions"
                    :error-messages="errors"
                    :disabled="status.isRequired"
                    item-text="text"
                    item-value="value"
                    label="Thuộc G *"
                    color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-center">
                <span class="mr-5">Lựa chọn màu sắc :</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="selectedColor "
                      dark
                      elevation="0"
                      v-on="on"
                      height="30px"
                    >

                    </v-btn>
                  </template>
                  <v-color-picker
                    v-model="selectedColor"
                    hide-canvas 
                    hide-inputs 
                    show-swatches
                  >
                  </v-color-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-0 group-btn--form">
          <v-btn
            color="success"
            @click.prevent="handleSubmit(saveContactStatus)"
          >
            Lưu lại
          </v-btn>

          <v-btn
            class="ml-0"
            color="primary"
            @click="hideModal"
          >
            Hủy bỏ
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import { contactStatusDefaultColor  } from '../../../helpers/constants'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import {
    contactStatusTOptions,
    contactStatusCOptions,
    contactStatusMOptions,
    contactStatusGOptions,
    regex,
  } from '../../../helpers/constants';
  const ContactStatusRepository = RepositoryFactory.get('contact_status')
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    data () {
      return {
        showModal: false,
        isCreate: true,
        status: {},
        contactStatusTOptions,
        contactStatusCOptions,
        contactStatusMOptions,
        contactStatusGOptions,
        regex,
        selectedColor: '',
      }
    },
    created () {
      Bus.$on('close-contact-status-modal', () => {
        this.showModal = false
      })

      Bus.$on('show-contact-status-form-modal', (status) => {
        this.showModal = true

        if (!status.color) {
          this.selectedColor = contactStatusDefaultColor
        } else {
          this.selectedColor = status.color
        }

        if (status.id) {
          this.isCreate = false
        } else {
          this.isCreate = true
        }

        this.status = _.cloneDeep(status)
        this.status.type = status.type ? status.type.slice(-2) : ''
      })
    },

    beforeDestroy() {
      Bus.$off('close-contact-status-modal')
      Bus.$off('show-contact-status-form-modal')
    },

    methods: {
      hideModal () {
        this.showModal = false
        this.selectedColor = ''
        this.$refs.validator.reset()
      },
      
      saveContactStatus() {
        Bus.$emit('save-contact-status', {
          ...this.status,
          color: this.selectedColor || contactStatusDefaultColor
        }, this.isCreate)
      }
    },
  }
</script>

<style scoped>
/deep/ .input-code input {
  text-transform: uppercase;
}
</style>